import CompanyUsers from './CompanyUsers';

export default CompanyUsers;
